import React from "react";
import { cls } from "cls";
import {
  FeatureImageStyle,
  FeatureItemModel,
  LinkStyle,
  ButtonUrlType,
  LeadGenStyle,
} from "../Models/PageCreatorPage";
import ButtonLink from "./ButtonLink";
import { getSanitizedHtml } from "../Utilities/htmlInputUtility";

export interface LeadGenFeatureItemProps {
  imageStyle: FeatureImageStyle;
  item: FeatureItemModel;
  linkStyle: LinkStyle;
  sectionStyle?: LeadGenStyle;
}

const LeadGenFeatureItem = ({
  imageStyle,
  item,
  linkStyle,
  sectionStyle,
}: LeadGenFeatureItemProps): JSX.Element => {
  return (
    <div
      id="feature-item"
      className={`${cls(
        "flex",
        "flex-col",
        imageStyle === FeatureImageStyle.icon ? "p-4" : "",
        "gap-6",
        "items-center",
        "sm:items-start",
      )}`}
    >
      <img
        id="content-img"
        src={item.imageUrl}
        alt={item.imageAltText}
        className={cls(
          imageStyle === FeatureImageStyle.image
            ? "w-full sm:place-self-center"
            : "w-fit sm:place-self-start",
          imageStyle === FeatureImageStyle.image &&
            sectionStyle !== LeadGenStyle.FeatureContainer
            ? "rounded-t-[3px]"
            : "",
        )}
      />
      <div
        className={cls(
          "flex",
          "flex-col",
          imageStyle === FeatureImageStyle.image &&
            sectionStyle !== LeadGenStyle.FeatureContainer
            ? "px-6"
            : "",
          imageStyle === FeatureImageStyle.image ? "pb-6" : "",
          "items-start",
          "self-start",
          "text-left",
          "justify-between",
        )}
      >
        <h3
          className={cls("text-xl", "font-bold", "mb-0", "leading-tight")}
          style={{ color: item.textColor, textShadow: "none" }}
        >
          {item.header}
        </h3>
        <p
          className={cls("text-base", "leading-tight", "mt-1", "mb-0")}
          style={{ color: item.textColor }}
        >
          {getSanitizedHtml(item.bodyText)}
        </p>
        {linkStyle === LinkStyle.text && (
          <a
            className={cls(
              "text-base",
              "font-semibold",
              "mb-0",
              "mt-4",
              "cursor-pointer",
              "w-fit",
              "hover:underline",
            )}
            style={{ color: item.buttonTextColor }}
            href={item.buttonUrl}
            target={
              item.buttonUrlType === ButtonUrlType.section ? "_self" : "_blank"
            }
          >
            {item.buttonText}
          </a>
        )}
        {linkStyle === LinkStyle.button &&
          !!item.buttonBackgroundColor &&
          !!item.buttonTextColor &&
          !!item.buttonText && (
            <ButtonLink
              backgroundColor={item.buttonBackgroundColor}
              textColor={item.buttonTextColor}
              buttonUrl={item.buttonUrl}
              buttonUrlType={item.buttonUrlType}
              text={item.buttonText}
              buttonExtraClassNames="mt-4"
            />
          )}
      </div>
    </div>
  );
};

export default LeadGenFeatureItem;
